import { NavButtonsContainer } from "@src/common/styled-components";
import { APP_ROUTES } from "@src/constants";
import { MEDIA_QUERIES } from "@src/constants/media-queries";
import { useNavigateWithUTM } from "@src/hooks/useNavigateWithUTM";
import { useMediaQuery } from "@uhg-abyss/web/hooks/useMediaQuery";
import { Button } from "@uhg-abyss/web/ui/Button";

interface FormFooterProps {
  isLoading?: boolean;
  isUiBlocked?: boolean;
}

export const FormFooter = ({ isLoading = false, isUiBlocked = false }: FormFooterProps) => {
  const isMobile = useMediaQuery(MEDIA_QUERIES.mobileMax);
  const navigate = useNavigateWithUTM();

  return (
    <NavButtonsContainer isMobile={isMobile}>
      <Button
        data-testid="test-id-patient-screener-back-button"
        {...(!isMobile && {
          icon: {
            icon: "chevron_left",
            position: "leading",
            variant: "outlined",
          },
        })}
        id="obc-patient-screener-back-btn"
        data-obc-label="Patient Screener Back Button"
        onClick={() => {
          navigate(APP_ROUTES.GET_STARTED);
        }}
        variant={isMobile ? "text" : "outline"}
        size={isMobile ? "lg" : "md"}
        type="button"
      >
        Back
      </Button>
      <Button
        data-testid="test-id-patient-screener-next-button"
        css={isMobile ? { width: "100%" } : undefined}
        icon={
          isMobile
            ? undefined
            : {
                icon: "chevron_right",
                position: "trailing",
                variant: "outlined",
              }
        }
        size={isMobile ? "lg" : "md"}
        variant="filled"
        type="submit"
        form="obc-patient-screener-form"
        id="obc-patient-screener-next-btn"
        data-obc-label="Patient Screener Next Button"
        isDisabled={isLoading || isUiBlocked}
      >
        Next
      </Button>
    </NavButtonsContainer>
  );
};
